import React from 'react';
import Navigation from './navigation';
import IdeaIcon from './idea-icon';
import BlogIcon from './blog-icon';
import ContestIcon from './contest-icon';

export default class AppHome extends React.Component {
    render() {
        const iconStyles = {
            maxWidth: 90,
            maxHeight: 90,
            margin: '0 auto 40px',
        };
        return (
            <div>
                <Navigation {...this.props} />
                <div className="min-h-screen bg-gray-200 p-4">
                    <div className="max-w-6xl mx-auto text-center">
                        <img
                            className="inline-block"
                            style={{ maxHeight: 220 }} src={require('../assets/WestRoom.png')} alt="West Cancer Spark"/>
                        <h2 className="text-xl text-gray-900 font-bold my-4">WE ARE IGNITING CHANGE.</h2>
                        <p className="text-lg text-gray-900">Here in The West Room, we encourage everyone within our West family to share their ideas right here! Our diverse associate population grants us different perspectives on situations and processes each and every day – and we want to hear about it! Be sure to share your thoughts with us on the IDEAS page, while engaging with our Chaplain and other supportive care staff on our BLOG site. Should you have any questions, please contact <a className="text-west-green font-semibold" href="mailto:spark@westclinic.com">marketing@westclinic.com</a>.</p>
                        <div className="mt-12 flex justify-between flex-col md:flex-row bg-gray-200 mb-10">
                            <div onClick={() => this.props.history.push('/ideas')} className="mb-12 md:mb-0 py-10 px-20 bg-white shadow-xl rounded-lg overflow-hidden text-center w-full md:w-1/4 mr-4">
                                <div style={iconStyles}>
                                    <IdeaIcon />
                                </div>
                                <div className="cursor-pointer p-4 bg-west-green hover:bg-west-green-400 items-center text-white leading-none rounded-full flex inline-flex">
                                    Ideas
                                </div>
                            </div>
                            <div onClick={() => this.props.history.push('/posts')} className="mb-12 md:mb-0 py-10 px-20 bg-white shadow-xl rounded-lg overflow-hidden text-center w-full md:w-1/4 mr-4">
                                <div style={iconStyles}>
                                    <BlogIcon />
                                </div>
                                <div className="cursor-pointer p-4 bg-west-green hover:bg-west-green-400 items-center text-white leading-none rounded-full flex inline-flex">
                                    Blog
                                </div>
                            </div>
                            <div onClick={() => this.props.history.push('/contests')} className="mb-12 md:mb-0 py-10 px-20 bg-white shadow-xl rounded-lg overflow-hidden text-center w-full md:w-1/4 mr-4">
                                <div style={iconStyles}>
                                    <ContestIcon />
                                </div>
                                <div className="cursor-pointer p-4 bg-west-green hover:bg-west-green-400 items-center text-white leading-none rounded-full flex inline-flex">
                                    Contests
                                </div>
                            </div>
                            <div onClick={() => this.props.history.push('/cheers')} className="mb-12 md:mb-0 py-10 px-20 bg-white shadow-xl rounded-lg overflow-hidden text-center w-full md:w-1/4">
                                <div style={iconStyles}>
                                    <img src={require('../assets/cheers.png')} />
                                </div>
                                <div className="cursor-pointer p-4 bg-west-green hover:bg-west-green-400 items-center text-white leading-none rounded-full flex inline-flex">
                                    Cheers
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/app-home.js